import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Availability } from '../../objects/availability';
import { BaseService } from './base.service';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityService extends BaseService {
  createInstance = (attributes: Availability): Availability => attributes;

  getAvailabilities(payload: {
    productId: number;
    destinationId: number;
    startDate: Date;
    endDate: Date;
  }): Observable<Availability[]> {
    const {
      productId,
      destinationId,
      startDate,
      endDate,
    } = payload;

    const url = `products/${
      productId }/availabilities?product_id=${
      productId }&destination_id=${
      destinationId }&from_date=${
        format(startDate, 'yyyy-MM-dd') }&to_date=${
        format(endDate, 'yyyy-MM-dd') }`;

    return super.doGetAll(url, null, null);
  }
}
